import {
   CurrentHealthcareProviderDashboardModuleConfigurationQuery,
   DashboardModuleConfiguration,
} from '@dreryk/egabinet-dashboard-frontend-api';
import { CurrentPractitionerQuery, PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsFind, useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../translations';

type DashboardLoaderRenderProps = {
   practitionerDetails: PractitionerDetails;
   dashboardModuleConfiguration: DashboardModuleConfiguration | null;
};

type DashboardLoaderProps = {
   readonly children: (renderProps: DashboardLoaderRenderProps) => JSX.Element;
};

export const DashboardLoader = (props: DashboardLoaderProps): JSX.Element => {
   const {
      data: practitionerDetails,
      loading: practitionerDetailsLoading,
      error: practitionerDetailsError,
   } = useCqrsGet<PractitionerDetails>(() => new CurrentPractitionerQuery());

   const {
      data: dashboardModuleConfiguration,
      loading: dashboardModuleConfigurationLoading,
      error: dashboardModuleConfigurationError,
   } = useCqrsFind<DashboardModuleConfiguration>(
      () => new CurrentHealthcareProviderDashboardModuleConfigurationQuery()
   );

   if (practitionerDetailsLoading || dashboardModuleConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (practitionerDetailsError || dashboardModuleConfigurationError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={dashboardTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      practitionerDetails: practitionerDetails,
      dashboardModuleConfiguration: dashboardModuleConfiguration,
   });
};
